import React from "react"

import { IconSize } from "shared/types/Icon"
import { ValidityIndicator } from "shared/ui/validity-indicator/ValidityIndicator"

import { useProductStatusTranslation } from "entities/products/model/useProductStatusTranslation"
import { PRODUCT_POSITION_TABLE_STATUS_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowStatusCellProps
  extends ProductPositionRowCellProps {
  isValid: boolean | undefined
  isLoading?: boolean
}

export const ProductPositionRowStatusCell = React.memo(
  React.forwardRef(
    (
      { isValid, isLoading, ...rest }: ProductPositionRowStatusCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const status = useProductStatusTranslation(isValid)

      return (
        <ProductPositionTableCell
          ref={ref}
          aria-labelledby={PRODUCT_POSITION_TABLE_STATUS_HEADER_ID}
          className="status"
          data-testid="status-cell"
          tooltip={status && !isLoading ? status : null}
          {...rest}
        >
          <div className="visually-hidden" data-testid="screen-reader-status">
            {status}
          </div>
          <ValidityIndicator
            isValid={isValid}
            isLoading={isLoading}
            size={IconSize.SMALL}
          />
        </ProductPositionTableCell>
      )
    }
  )
)
